import { registerErrorHandler } from '@piri/error';
import { DialogColors } from '@/components/dialogs/constants';

import ToastError from './ToastError';

const alertErrorHandler = error => {
  window.app.$toast(error.message, { color: DialogColors.ERROR });
};

registerErrorHandler(ToastError.key, alertErrorHandler);
